module.exports = __webpack_public_path__ + "static/img/liandong2.786cbc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/liandong2.png
// module id = NVoS
// module chunks = 24